import { SplitScreenService } from 'src/app/game/splitScreen.service';
import { Injectable, OnDestroy } from '@angular/core';
import { NavController, ModalController, ToastController } from '@ionic/angular';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { AppStoreDispatcher } from '../state/app.state.dispatcher';
import { Router } from '@angular/router';
import {
    DocumentData,
    CollectionReference,
    Firestore,
    query,
    orderBy,
    collection,
    getDocs,
    doc,
    getDoc,
    DocumentReference,
    docData,
    collectionData,
    updateDoc,
    limit,
    where,
    getCountFromServer,
    DocumentChange,
    fromRef,
} from '@angular/fire/firestore';
import { SopoLoadingService } from 'src/app/shared/services/sopo-loading/sopo-loading.service';
import {
    ITableRules,
    ISitNGoTournamentRules,
    ITableSettings,
    ISitNGoTournamentSettings,
    MemberID,
    ClubRole,
    IMultiTableTournamentSettings,
    IMultiTableTournamentRules,
    CreateTablePayload,
    CreateSngPayload,
    CreateMttPayload,
    IClubState,
    IClubMember,
    IMultiDayTournamentSettings,
    CurrencyType,
    IAcceptUnionPayload,
    IRequestToJoinClubPayload,
    ICreateClubPayload,
    IClubGame,
    MainServerResponseError,
} from '@soposopo/sopo-models';
import { Observable, Subscription, Subject, of, EMPTY, firstValueFrom, from } from 'rxjs';
import { ClubStateDispatcher } from '../state/club/club.dispatcher';
import { takeUntil, distinctUntilChanged, filter, map, catchError, take, switchMap } from 'rxjs/operators';
import { ProfileStateDispatcher } from '../state/profile/profile.dispatcher';
import { FireSubService } from './fireSub.service';
import { ClubMessage } from '../state/club/club.state';
import * as _ from 'lodash';
import { ApiService } from '../backend/api.service';
import { SmartAudioService } from 'src/app/shared/services/smart-audio/smart-audio.service';
import { DEFAULT_DISMISS_AFTER_TIME, SopoPopupService, ViewContainerName } from 'src/app/sopo-popup/service/sopo-popup.service';
import { AuthStoreDispatcher } from '../state/auth/auth.dispatcher';
import { IBountySettings } from '@soposopo/sopo-models/dist/bounty/bounty';
import { ProfileService} from './profile.service';
import { ClubLobbyDispatcher } from '../state/clubLobby/clubLobby.dispatcher';
import { SopoTransitionService } from 'src/app/shared/services/sopo-transition/sopo-transition.service';
import { DynamicLinkService } from './dynamic-link.service';
import { Clipboard } from '@capacitor/clipboard';
import { GameStoreDispatcher } from '../state/game/game.dispatcher';
import { GameToLoad } from '../state/game/game.state';
import { SopoAlertSettings } from 'src/app/sopo-popup/interfaces/alert';

@Injectable({
    providedIn: 'root',
})
export class ClubService implements OnDestroy {
    ngUnsubscribe = new Subject<void>();
    private clubSubscription: Subscription;
    private clubMessagesSubscription: Subscription;
    private membersSubscription: Subscription;
    roleSubscription: Subscription;
    lastInsertedTable: any;
    hitOnce = 0;
    club: any;
    tableFiltered: any;
    newTableKey: string;
    clubID = "SOPO";
    currentTables: any;
    currentClub: any;
    tableSubscribe: Subscription;
    appData: any;
    myRole: string;

    constructor(
        private loadingCtrl: SopoLoadingService,
        public cloudFNs: Functions,
        public appStateDispatch: AppStoreDispatcher,
        public firestore: Firestore,
        public navCtrl: NavController,
        public modalCtrl: ModalController,
        public clubStateDispatch: ClubStateDispatcher,
        private fireSubService: FireSubService,
        private apiService: ApiService,
        private smartAudioService: SmartAudioService,
        private sopoPopupService: SopoPopupService,
        private authStoreDispatcher: AuthStoreDispatcher,
        private profileService: ProfileService,
        private clubLobbyDispatcher: ClubLobbyDispatcher,
        private sopoTransitionService: SopoTransitionService,
        private dynamicLinkService: DynamicLinkService,
        private toastCtrl: ToastController,
        private gameStoreDispatcher: GameStoreDispatcher,
        private splitScreenService: SplitScreenService,
    ) {}

    async joinClub(clubCode: string, referralCode: number) {
        try {
            this.loadingCtrl.present('api');
            const myId = await this.authStoreDispatcher.getMyID();
            await this.apiService.callClubFunction<'requestToJoinClub', IRequestToJoinClubPayload>(
                'requestToJoinClub',
                {
                    userID: myId,
                    clubCode: clubCode,
                    referralCode: referralCode,
                }
            )
            this.loadingCtrl.dismiss('api');
        } catch (error) {
            this.loadingCtrl.dismiss('api');
            throw error;
        }
    }

    async createClub(name: string) {
        try {
            this.loadingCtrl.present('api');
            const myId = await this.authStoreDispatcher.getMyID();
            this.roleSubscription = this.profileService
            .getPublicUserInfoObservable(myId)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((userData) => {
            if (userData != null) {
                this.myRole = userData.role ? userData.role : 'user';
            }
            });
            this.fireSubService.registerSubscription(this.roleSubscription);
            const createdClub = await this.apiService.callClubFunction<'createClub', ICreateClubPayload>(
                'createClub',
                { founderID: myId, clubName: name.trim() }
            );
            if (this.myRole === 'user') {
                this.changeUserRole(myId);
            }

            const clubDocRef = doc(this.firestore, `users/${myId}/clubs/${createdClub.clubID}`);
            await firstValueFrom(docData(clubDocRef).pipe(
                filter(data => data !== undefined),
                take(1),
            ));

            this.loadingCtrl.dismiss('api');

            this.goToClub(createdClub.clubID);
        } catch (error) {
            this.loadingCtrl.dismiss('api');
            throw error;
        }
    }

    async goToClub(id: string) {
        await this.sopoTransitionService.openTransition();
        this.navCtrl.navigateRoot(`club-lobby/${id}`);
        this.clubStateDispatch.activateComponent('games');
    }

    async changeUserRole(myId: string) {
        const payload = {
            uid: myId,
            role: 'owner',
        };
        const fn = httpsCallable(this.cloudFNs, 'userRoleChange');
        return fn(payload)
            .then(async (value) => {
                // TODO: Refactor to remove dependency of modal and nav ctrl?
                return payload;
            })
            .catch(async (error) => {
                return error;
            });
    }

    public loadClubMessages(clubID: string, limitTo: number = 30) {
        if(this.clubMessagesSubscription) this.clubMessagesSubscription.unsubscribe();
        const collectionReference = collection(this.firestore, `clubs/${clubID}/messages`) as CollectionReference<ClubMessage>;
        const collectionQuery = query(collectionReference, orderBy('dateCreated', 'desc'), limit(limitTo));
        this.clubMessagesSubscription = collectionData<ClubMessage>(collectionQuery, { idField: 'messageID' })
            .subscribe((messages) => {
                this.clubStateDispatch.loadClubMessages(messages);
            });
        this.fireSubService.registerSubscription(this.clubMessagesSubscription);
    }

    public isUserAllowedForClubChatNotifications( userID:string, clubID: string) : Observable<boolean> {
        if (clubID == null) {
            throw new Error(`Cannot get club data of clubID === null`);
        }
        if (userID == null) {
            throw new Error(`Cannot get user data userID id === null`);
        }
        const docReference = doc(this.firestore, `users/${userID}/clubs/${clubID}`);
        return docData(docReference)
            .pipe(
                filter((data) => data != null),
                map((userData: any) => {
                    if (userData['chatNotificationDisabled']) {
                        return false;
                    } else {
                        return true;
                    }
                }),
                distinctUntilChanged()
            );
    }

    public setChatNotificationRight (userID: string, clubID: string, disabled : boolean) {
        if (clubID == null) {
            throw new Error(`Cannot use parameter clubID === null`);
        }
        if (userID == null) {
            throw new Error(`Cannot use parameter userID id === null`);
        }
        if (disabled == null) {
            throw new Error(`Cannot use parameter disabled === null`);
        }

        const docReference = doc(this.firestore, `users/${userID}/clubs/${clubID}`);
        updateDoc(docReference, {
            chatNotificationDisabled : disabled,
        });
    }

    public async watchClub(clubId: string): Promise<void> {
        if (this.clubID === clubId) return;
        this.clubID = clubId;
        this.clubStateDispatch.enterClub(clubId);
        if (this.clubSubscription && !this.clubSubscription.closed) this.stopWatchingClub(false);
        if (clubId !== 'SOPO') {
            const docReference = doc(this.firestore, `clubs/${clubId}`) as DocumentReference<IClubState>;
            this.clubSubscription = docData<IClubState>(docReference)
                .pipe(
                    map(data => data),
                    catchError((error, caught) => {
                        const errorCode = error.code ? error.code : '';
                        const message = error.message ? error.message : 'Error in watchClub function.'
                        console.log(errorCode + ' - ' + message + ' - ' + this.clubID);
                        return caught;
                    }),
                    distinctUntilChanged(),
                    takeUntil(this.ngUnsubscribe),
                )
                .subscribe((clubData) => {
                    this.clubStateDispatch.loadData(clubData);
                });
            this.fireSubService.registerSubscription(this.clubSubscription);
        }
    }

    public stopWatchingClub(resetClubId = true) {
        if (this.clubSubscription) this.clubSubscription.unsubscribe();
        if (this.membersSubscription) this.membersSubscription.unsubscribe();
        if (this.clubMessagesSubscription) this.clubMessagesSubscription.unsubscribe();
        this.ngUnsubscribe.next();
        this.clubStateDispatch.setClubListening(false);
        this.clubStateDispatch.setMembersListening(false);
        this.clubStateDispatch.clearMembersState();
        this.clubStateDispatch.clearMessages();
        if (resetClubId) {
            this.clubID = 'SOPO';
            this.clubStateDispatch.enterClub('SOPO');
        }
    }

    async watchClubMembers() {
        const clubId = await this.clubStateDispatch.getClubID();
        if (this.membersSubscription && !this.membersSubscription.closed) return;
        if (clubId !== 'SOPO') {
            const collectionRef = collection(this.firestore, `clubs/${clubId}/members`) as CollectionReference<IClubMember>;
            this.membersSubscription = fromRef(collectionRef, { includeMetadataChanges: false }).pipe(
                map(currentSnapshot => currentSnapshot.docChanges()),
                filter(doc => doc.length > 0),
                takeUntil(this.ngUnsubscribe)
            ).subscribe(async (members) => {
                const numberOfMembers = (await getCountFromServer(collectionRef)).data().count;
                this.handleMemberChanges(members, numberOfMembers);
            });
        }
    }

    handleMemberChanges(members: DocumentChange<IClubMember>[], numberOfMembers: number) {
        let addedMembers: IClubMember[] = [];
        let modifiedMembers: IClubMember[] = [];
        let removedMembers: IClubMember[] = [];

        members.forEach(member => {
            switch(member.type){
                case 'added':
                    addedMembers.push(member.doc.data());
                    break;
                case 'modified':
                    modifiedMembers.push(member.doc.data());
                    break;
                case 'removed':
                    removedMembers.push(member.doc.data());
                    break;
            }
        });

        if(addedMembers.length > 0) this.clubStateDispatch.membersLoaded(addedMembers, numberOfMembers);
        if(modifiedMembers.length > 0) modifiedMembers.forEach(modified => this.clubStateDispatch.memberModified(modified));
        if(removedMembers.length > 0) removedMembers.forEach(removed => this.clubStateDispatch.memberRemoved(removed, numberOfMembers));
    }


    public async getBotNumber(): Promise<number> {
        const clubState = await firstValueFrom(this.clubStateDispatch.getClubState());

        if (clubState.membersState.listening) {
            const members = clubState.membersState.members;
            return members.reduce((val, member) => member.id.includes('bot_') ? ++val : val, 0)
        }
        else {
            const collectionReference = collection(this.firestore, `clubs/${clubState.id}/members`);
            const collectionQuery = query(collectionReference, where('id', '>=', 'bot_'), where('id', '<', 'bot_\uf8ff'));
            return (await getCountFromServer(collectionQuery)).data().count;
        }
    }

    public getBotMembersObservable(clubId: string): Observable<IClubMember[]> {
        const collectionReference = collection(this.firestore, `clubs/${clubId}/members`);
        const collectionQuery = query(collectionReference,
            where('id', '>=', 'bot_'),
            where('id', '<', 'bot_\uf8ff'),
            limit(20),
        );

        return from(getDocs(collectionQuery)).pipe(
            map(querySnapshot => querySnapshot.docs.map(doc => doc.data() as IClubMember)),
        );
    }

    public async assignAgent(memberID: string, agentID: string) {
        return this.appStateDispatch.getStateSnapshot().then((appState) => {
            const userData = appState.auth.userData;
            if (userData == null) {
                throw new Error(`Club service cannot create table because user not authorized`);
            }
            const payload = {
                adminID: userData.uid,
                clubID: appState.club.clubData.id,
                memberID,
                agentID,
            };

            this.throwsIfUndefined(payload);

            const successHeader = {
                message: `Agent assigned.`,
            };

            return this.callClubFunction(`assignAgent`, payload, successHeader);
        });
    }

    public async releaseAgent(memberID: string) {
        return this.appStateDispatch.getStateSnapshot().then((appState) => {
            const userData = appState.auth.userData;
            if (userData == null) {
                throw new Error(`Club service cannot create table because user not authorized`);
            }
            const payload = {
                adminID: userData.uid,
                clubID: appState.club.clubData.id,
                memberID,
            };

            this.throwsIfUndefined(payload);

            const successHeader = {
                message: `Agent released.`,
            };

            return this.callClubFunction(`releaseAgent`, payload, successHeader);
        });
    }

    public async addSopoBalance(balance: number, adminID: string, clubID: string) {
        getDocs(collection(this.firestore, `account`))
            .then((snapshot) => {
                if (snapshot.docs && snapshot.docs[0]) {
                    this.appData = snapshot.docs[0].data();
                    let sopoBalance = balance;
                    let collectionID = '';
                    if (this.appData) {
                        sopoBalance += this.appData.sopoBalance;
                        collectionID = this.appData.id;
                    }
                    const payload = {
                        balance,
                        adminID,
                        clubID,
                        sopoBalance,
                        collectionID,
                    };

                    this.throwsIfUndefined(payload);

                    const successHeader = {};
                    return this.callClubFunction(`addToSopoBalance`, payload, successHeader);
                }
            });
    }

    public async convertWithDiamonds(transaction: any, diamond: number) {
        return this.appStateDispatch.getStateSnapshot().then((appState) => {
            const userData = appState.auth.userData;
            if (userData == null) {
                throw new Error(`Shop service cannot buy diamonds because user not authorized`);
            }
            const payload = {
                userID: userData.uid,
                diamond: diamond,
                transaction,
            };

            this.throwsIfUndefined(payload);

            const successHeader = {};

            return this.callCloudFunction(`buyWithDiamonds`, payload, successHeader);
        });
    }

    public async purchaseItem(currency: 'diamond' | 'gold', transactions: any, diamond: number) {
        return this.appStateDispatch.getStateSnapshot().then((appState) => {
            const userData = appState.auth.userData;
            if (userData == null) {
                throw new Error(`Shop service cannot buy item because user not authorized`);
            }
            if (transactions.appliedPromo === undefined) transactions.appliedPromo = '';
            const payload = {
                userID: userData.uid,
                diamond: diamond,
                transactions,
                currency: currency
            };

            this.throwsIfUndefined(payload);

            const successHeader = {};

            return this.callClubFunction(`buyWithCurrency`, payload, successHeader);
        });
    }

    public async purchaseBundle(transactions: any, amount: number, count: number, currency: "diamond" | "gold", bypassLoading = false) {
        return this.appStateDispatch.getStateSnapshot().then((appState) => {
            const userData = appState.auth.userData;
            if (userData == null) {
                throw new Error(`Shop service cannot buy ${transactions.itemType} because user not authorized`);
            }
            const payload = {
                userID: userData.uid,
                amount: amount,
                count,
                transactions,
                currency: currency
            };

            this.throwsIfUndefined(payload);

            const successHeader = {
                header: `Purchase is successful.`,
                message: `It may take a few moments for the ${transactions.itemType} count update.`,
            };

            return this.callClubFunction(`bundlePurchaseWithCurrency`, payload, successHeader, bypassLoading);
        });
    }

    public async submitSettingForItem(item: {id: number}, pluralType: keyof ItemTypes) {
        return this.appStateDispatch.getStateSnapshot().then(async (appState) => {
            const userData = appState.auth.userData;
            if (userData == null) {
                throw new Error(`user not authorized (null)`);
            }
            const payload = {
                itemToBeSet: item,
                itemType: pluralType
            };

            this.throwsIfUndefined(payload);

            try {
                this.loadingCtrl.present('api');

                this.apiService.onSettingsChanged(payload, userData.uid)

                this.loadingCtrl.dismiss('api');
                return payload;
            } catch(error) {
                this.loadingCtrl.dismiss('api');
                console.error(error);
                this.sopoPopupService.clearViewContainer('app');
                const sopoAlertSettings: SopoAlertSettings = {
                    header: `onSettingsChanged Error`,
                    message: error.error,
                    dismissAfter: 5000,
                    sCss: ['sopo-popup-red-background'],
                };
                this.sopoPopupService.showAlert('app', sopoAlertSettings);
                return error;
            }
        });
    }

    public async sendConvertedChips(chips: number): Promise<{ success: boolean; error?: any }> {
        return this.appStateDispatch.getStateSnapshot().then((appState) => {
            const userData = appState.auth.userData;
            if (userData == null) {
                throw new Error(`Club service cannot send chips because user not authorized`);
            }
            const payload = {
                adminID: userData.uid,
                clubID: appState.club.clubData.id,
                chips: chips,
            };

            this.throwsIfUndefined(payload);

            const successHeader = {
                header: `Chips Added.`,
                message: `It may take a few moments for the balances to reflect this change.`,
            };

            return this.callClubFunction(`sendConvertedChips`, payload, successHeader);
        });
    }

    public async createTable(tableSettings: ITableSettings, tableRules: ITableRules, currentTables: any) {
        const appState = await this.appStateDispatch.getStateSnapshot();
        const userData = appState.auth.userData;

        if (userData == null) {
            throw new Error(`Club service cannot create table because user not authorized`);
        }

        this.currentTables = currentTables;
        const payload: CreateTablePayload = {
            adminID: userData.uid,
            tableID: '',
            clubID: appState.club.clubData.id,
            tableSettings: tableSettings,
            tableRules: tableRules,
            isUnion: appState.club.clubData.isUnion ? appState.club.clubData.isUnion : false,
            allTables: [],
            currency: CurrencyType.CHIP,
        };

        this.throwsIfUndefined(payload);

        this.loadingCtrl.present('cloud');

        await this.apiService.createTable(payload).then(
            async (response) =>{
                this.loadingCtrl.dismiss('cloud');
                this.navCtrl.navigateBack(`club-lobby/${payload.clubID}`);
                this.sopoPopupService.clearViewContainer('app');
                const sopoAlertSettings: SopoAlertSettings = {
                    header: 'Table Created',
                    message: 'It may take a few moments to show up in your club lobby.',
                    dismissAfter: DEFAULT_DISMISS_AFTER_TIME,
                    sCss: ['sopo-popup-red-background'],
                };
                this.sopoPopupService.showAlert('app', sopoAlertSettings);
            },
            async (reason) => {
                this.loadingCtrl.dismiss('cloud');
                this.sopoPopupService.clearViewContainer('app');
                const sopoAlertSettings: SopoAlertSettings = {
                    header: 'Table Creation failed',
                    message: reason.error,
                    dismissAfter: DEFAULT_DISMISS_AFTER_TIME,
                    sCss: ['sopo-popup-red-background'],
                };
                this.sopoPopupService.showAlert('app', sopoAlertSettings);
                console.error(reason);
            }
        );

        this.hitOnce = 0;
    }

    public async createSitNGoTournament(
        sngSettings: ISitNGoTournamentSettings,
        sngRules: ISitNGoTournamentRules,
        currentTables: any,
    ): Promise<boolean> {
        const appState = await this.appStateDispatch.getStateSnapshot();
        const userData = appState.auth.userData;
        if (userData == null) {
            throw new Error(`Club service cannot create SnG tournament because user not authorized`);
        }

        const payload: CreateSngPayload = {
            adminID: userData.uid,
            tournamentID: '',
            clubID: appState.club.clubData.id,
            sngSettings: sngSettings,
            sngRules: sngRules,
            isUnion: appState.club.clubData.isUnion ? appState.club.clubData.isUnion : false,
            allTables: currentTables,
            tournamentType: 'SNG',
            currency: CurrencyType.CHIP,
        };

        this.throwsIfUndefined(payload);

        this.loadingCtrl.present('cloud');
        this.hitOnce = 0;

        // Returns true on success / false on failure so the caller
        // (create-table.page) can keep the form open and avoid firing the
        // success-only side effects (lobby filter change, analytics event)
        // when the BE rejects the config.
        return this.apiService.createTournament(payload).then(
            async () => {
                this.loadingCtrl.dismiss('cloud');
                this.navCtrl.navigateBack(`club-lobby/${payload.clubID}`);
                this.sopoPopupService.clearViewContainer('app');
                this.sopoPopupService.showAlert('app', {
                    header: 'Tournament created successfully',
                    message: 'It may take a few moments to show up in your club lobby.',
                    dismissAfter: DEFAULT_DISMISS_AFTER_TIME,
                    sCss: ['sopo-popup-red-background'],
                });
                return true;
            },
            async (reason) => {
                this.loadingCtrl.dismiss('cloud');
                this.sopoPopupService.clearViewContainer('app');
                this.sopoPopupService.showAlert('app', {
                    header: 'Failed to create Tournament',
                    message: this.extractCreateTournamentErrorMessage(reason),
                    dismissAfter: DEFAULT_DISMISS_AFTER_TIME,
                    sCss: ['sopo-popup-red-background'],
                });
                console.error(reason);
                return false;
            },
        );
    }

    public async createMTTournament(
        settings: IMultiTableTournamentSettings,
        bountySettings: IBountySettings,
        rules: IMultiTableTournamentRules,
        currentTables: any,
        multiDayTournamentSettings: IMultiDayTournamentSettings,
    ): Promise<boolean> {
        const appState = await this.appStateDispatch.getStateSnapshot();
        const userData = appState.auth.userData;
        if (userData == null) {
            throw new Error(`Club service cannot create MTT tournament because user not authorized`);
        }
        const payload: CreateMttPayload = {
            adminID: userData.uid,
            tournamentID: '',
            clubID: appState.club.clubData.id,
            mttSettings: settings,
            mttBountySettings: bountySettings,
            mttRules: rules,
            isUnion: appState.club.clubData.isUnion ? appState.club.clubData.isUnion : false,
            allTables: currentTables,
            tournamentType: 'MTT',
            multiDayTournamentSettings: multiDayTournamentSettings,
            currency: CurrencyType.CHIP,
        };

        this.throwsIfUndefined(payload);

        this.loadingCtrl.present('cloud');
        this.hitOnce = 0;

        // Returns true on success / false on failure so the caller
        // (create-table.page) can keep the form open and avoid firing the
        // success-only side effects (lobby filter change, analytics event)
        // when the BE rejects the bounty config.
        return this.apiService.createMtTournament(payload).then(
            async () => {
                this.loadingCtrl.dismiss('cloud');
                this.navCtrl.navigateBack(`club-lobby/${payload.clubID}`);
                this.sopoPopupService.clearViewContainer('app');
                this.sopoPopupService.showAlert('app', {
                    header: 'Tournament created successfully',
                    message: 'It may take a few moments to show up in your club lobby.',
                    dismissAfter: DEFAULT_DISMISS_AFTER_TIME,
                    sCss: ['sopo-popup-red-background'],
                });
                return true;
            },
            async (reason) => {
                this.loadingCtrl.dismiss('cloud');
                this.sopoPopupService.clearViewContainer('app');
                this.sopoPopupService.showAlert('app', {
                    header: 'Failed to create Tournament',
                    message: this.extractCreateTournamentErrorMessage(reason),
                    dismissAfter: DEFAULT_DISMISS_AFTER_TIME,
                    sCss: ['sopo-popup-red-background'],
                });
                console.error(reason);
                return false;
            },
        );
    }

    public async disbandClub(clubID: string): Promise<{ success: boolean; error?: any }> {
        return this.appStateDispatch.getStateSnapshot().then((appState) => {
            const userData = appState.auth.userData;
            if (userData == null) {
                throw new Error(`Club service cannot disband club because user not authorized`);
            }
            const payload = {
                adminID: userData.uid,
                clubID: appState.club.clubData.id,
            };

            this.throwsIfUndefined(payload);

            const successHeader = {
                message: `Club Disbanded.`,
            };
            return this.callClubFunction(`disbandClub`, payload, successHeader,  false, true);
        });
    }

    /**
     *  Send chips to a member based on the selected member
     * @param chips number of chips to send
     */

    public async sendChips(chips: number, memberid: any, incomingClubId?: string, fromClub = false,): Promise<{ success: boolean; error?: any }> {
        return this.appStateDispatch.getStateSnapshot().then(async (appState) => {
            let clubID: string;
            const userData = appState.auth.userData;
            if (userData == null) {
                throw new Error(`Club service cannot send chips because user not authorized`);
            }

            if (!incomingClubId)
                clubID = appState.club.clubData.id;
            else
                clubID = incomingClubId;

            const payload = {
                adminID: userData.uid,
                clubID,
                chips: chips,
                members: memberid,
            };

            this.throwsIfUndefined(payload);

            const successHeader = {
                header: `Chips Issued.`,
                message: `It may take a few moments for the balances to reflect this change.`,
            };

            return this.callClubFunction(`sendChips`, payload, successHeader, false, fromClub);
        });
    }

    /**
     *  Send chips to a member based on the selected member
     * @param chips number of chips to reclaim
     */

    public async reclaimChips(chips: number, members: string[], incomingClubId?: string, fromClub = false,): Promise<{ success: boolean; error?: any }> {
        return this.appStateDispatch.getStateSnapshot().then(async (appState) => {
            let clubID: string;
            const userData = appState.auth.userData;
            if (userData == null) {
                throw new Error(`Club service cannot reclaim chips because user not authorized`);
            }

            if (!incomingClubId)
                clubID = appState.club.clubData.id;
            else
                clubID = incomingClubId;


            const payload = {
                adminID: userData.uid,
                clubID,
                chips: chips,
                members,
            };

            this.throwsIfUndefined(payload);

            const successHeader = {
                header: `Chips Reclaimed.`,
                message: `It may take a few moments for the balances to reflect this change.`,
            };

            return this.callClubFunction(`reclaimChips`, payload, successHeader, false, fromClub);
        });
    }

    /**
     * Change a club member's role
     * @param memberID the ID of the member whose role to change
     * @param role the to change the member to
     */
    public async setRole(memberID: MemberID, role: ClubRole): Promise<{ success: boolean; error?: any }> {
        return this.appStateDispatch.getStateSnapshot().then((appState) => {
            const userData = appState.auth.userData;
            if (userData == null) {
                throw new Error(`Club service cannot send chips because user not authorized`);
            }
            const payload = {
                adminID: userData.uid,
                memberID: memberID,
                role: role,
                clubID: appState.club.clubData.id,
            };

            this.throwsIfUndefined(payload);

            const successHeader = {
                message: `Member Role Set`,
            };

            return this.callClubFunction(`setClubRole`, payload, successHeader, false, true);
        });
    }

    public async leaveClub(memberID: string, clubID: string): Promise<{ success: boolean; error?: any }> {

        const payload = {
            clubID: clubID,
            memberID: memberID,
        };

        this.throwsIfUndefined(payload);

        const successHeader = {
            message: `You left the club.`,
        };

        await this.closeClubGames(clubID);

        this.clubLobbyDispatcher.destroySubscriptionsAndResetState();
        this.clubSubscription.unsubscribe();
        return this.callClubFunction(`leaveClub`, payload, successHeader);
    }

    async closeClubGames(clubID: string): Promise<void> {
        const gamesToClose: GameToLoad[] = await firstValueFrom(this.gameStoreDispatcher.getState().pipe(
            map(gameState => gameState.gamesList.filter(game => game.componentType === 'game' && game.clubId === clubID) as GameToLoad[])
        ));
        for (let game of gamesToClose) {
            await this.splitScreenService.closeGame(game.tableId);
        }
    }

    public async acceptAllMembers(
        members: any,
        adminID: string,
        clubID: string,
        fromClub = false
    ): Promise<{ success: boolean; error?: any }> {
        const payload = {
            adminID,
            clubID,
            members,
        };
        this.throwsIfUndefined(payload);

        const successHeader = {
            header: `Requests Accepted`,
            message: `All requests are accepted.`,
        };

        return this.callClubFunction(`acceptAllRequestToJoinClub`, payload, successHeader, false, fromClub);
    }

    public async rejectAllMembers(
        members: any,
        adminID: string,
        clubID: string,
    ): Promise<{ success: boolean; error?: any }> {
        const payload = {
            adminID,
            clubID,
            members,
        };
        this.throwsIfUndefined(payload);

        const successHeader = {
            header: `Requests Rejected`,
            message: `All requests are rejected.`,
        };

        return this.callClubFunction(`rejectAllRequestToJoinClub`, payload, successHeader, false, true);
    }

    public async acceptAllUnions(
        adminID: string,
        clubID: string,
        owner: any,
        clubTables: any,
        unionID: string,
        unionName: string,
    ) {
        const payload = {
            clubID,
            adminID,
            owner,
            clubTables,
            unionID,
            unionName,
        };
        this.throwsIfUndefined(payload);
        const successHeader = {
            header: `Request Accepted`,
            message: 'Union requests accepted successfully.',
        };
        console.log(payload);
        return this.callCloudFunction(`acceptAllUnion`, payload, successHeader);
    }

    public async acceptMember(
        userID: string,
        serviceClubId?: string,
        fromClub = false,
    ): Promise<{ success: boolean; error?: any }> {
        let clubID: string;
        if (!serviceClubId)
            clubID = await this.clubStateDispatch.getClubID();
        else
            clubID = serviceClubId;
        const adminID = await this.authStoreDispatcher.getMyID();

        const payload = {
            adminID,
            clubID,
            userID,
        };

        this.throwsIfUndefined(payload);

        const successHeader = {
            message: `Member Accepted.`,
        };

        return this.callClubFunction(`acceptRequestToJoinClub`, payload, successHeader, false, fromClub);
    }

    public async rejectMember(
        userID: string,
        serviceClubId?: string,
        fromClub = false,
    ): Promise<{ success: boolean; error?: any }> {
        let clubID: string;
        if (!serviceClubId)
            clubID = await this.clubStateDispatch.getClubID();
        else
            clubID = serviceClubId;
        const adminID = await this.authStoreDispatcher.getMyID();

        const payload = {
            adminID,
            clubID,
            userID,
        };

        this.throwsIfUndefined(payload);

        const successHeader = {
            message: `Member Rejected.`,
        };

        return this.callClubFunction(`denyRequestToJoinClub`, payload, successHeader, false, fromClub);
    }

    public async cancelPendingRequest(userID: string, clubID: string){
        const payload = {
            clubID,
            userID,
        };

        this.throwsIfUndefined(payload);

        const successHeader = {
            message: `Cancelled Join Request`,
        };
        return this.callClubFunction(`cancelRequestToJoinClub`, payload, successHeader, false, true);
    }

    public async makeClubUnion(
        isUnion: boolean,
        isUnionOwner: boolean,
        clubID: string,
        adminID: string,
        unionName: string,
    ) {
        const payload = {
            isUnion,
            isUnionOwner,
            clubID,
            adminID,
            unionName,
        };
        this.throwsIfUndefined(payload);
        const successHeader = {
            header: `Union Created`,
            message: 'Union created successfully.',
        };
        return this.callClubFunction(`createUnion`, payload, successHeader, false, true);
    }

    public async joinUnion(clubID: string, userID: string, unionCode: number) {
        const payload = {
            clubID,
            userID,
            unionCode,
        };
        this.throwsIfUndefined(payload);
        const successHeader = {
            header: `Join Union`,
            message: 'Request sent successfully.',
        };
        return this.callClubFunction(`requestToJoinUnion`, payload, successHeader, false, true);
    }

    public async rejectUnionRequest(clubID: string, adminID: string, ownerClubID: string, fromClub = false) {
        const payload = {
            clubID,
            adminID,
            ownerClubID,
        };
        this.throwsIfUndefined(payload);
        const successHeader = {
            header: `Request Rejected`,
            message: 'Union request rejected successfully.',
        };
        return this.callClubFunction(`rejectUnion`, payload, successHeader, false, fromClub);
    }

    public async acceptUnionRequest( payload: IAcceptUnionPayload, fromClub = false ) {
        this.throwsIfUndefined(payload);
        const successHeader = {
            header: `Request Accepted`,
            message: 'Union request accepted successfully.',
        };
        return this.callClubFunction(`acceptUnion`, payload, successHeader, false, fromClub);
    }

    public async updateClubMessage(userID: string, clubId: string, message: string) {
        const payload = {
            userID,
            clubId,
            message,
        };
        this.throwsIfUndefined(payload);
        const successHeader = {
            header: `Club message successfully updated`,
            message: `It may take a few moments to propagate the changes.`,
        };
        return this.callClubFunction(`updateClubMessage`, payload, successHeader, false, true);
    }

    public async renameClub(clubID: string, ownerID: string, clubName: string) {
        const payload = {
            clubID,
            ownerID,
            clubName,
        };
        this.throwsIfUndefined(payload);
        const successHeader = {
            header: `Club updated`,
            message: 'Club updated successfully.',
        };
        return this.callClubFunction(`renameClub`, payload, successHeader, false, true);
    }

    public async renameUnion(clubID: string, unionName: string, userID: string) {
        const payload = {
            clubID,
            unionName,
            userID,
        };
        this.throwsIfUndefined(payload);
        const successHeader = {
            header: `Union updated successfully`,
            message: `It may take a few moments to propagate the changes.`,
        };
        return this.callClubFunction(`renameUnion`, payload, successHeader, false, true);
    }

    private async callClubFunction(fnName: string, payload: any, successHeader: ISuccessHeader, bypassLoading = false, popUpInClub = false): Promise<any | Error> {
        if (fnName !== 'addToSopoBalance' && !bypassLoading) {
            this.loadingCtrl.present('api');
        }
        return this.apiService.callClubFunction<string, any>(fnName, payload)
            .then(async (value) => {
                if (!bypassLoading) this.loadingCtrl.dismiss('api');
                // TODO: Refactor to remove dependency of modal and nav ctrl?
                if (Object.keys(successHeader).length > 0) {
                    if (fnName === 'disbandClub') {
                        this.clubLobbyDispatcher.destroySubscriptionsAndResetState();
                        this.stopWatchingClub();
                        await this.navCtrl.navigateRoot('/lobby');
                        this.showAlert(successHeader.header, successHeader.message, 5000, popUpInClub);
                    }
                    if (fnName !== 'onSettingsChanged' && fnName !== 'disbandClub' && !bypassLoading) {
                        this.succesAlert(successHeader, popUpInClub);
                    }
                    if (fnName === 'bundlePurchaseWithCurrency') {
                        this.smartAudioService.playSounds('shop');
                    }
                }
                return payload;
            })
            .catch(async (error) => {
                this.loadingCtrl.dismiss('api');
                console.error(error);
                if (fnName == 'requestToJoinUnion') {
                    fnName = 'Join Union';
                }
                if (fnName == 'buyWithDiamonds' || fnName == "buyWithCurrency") {
                    fnName = 'Purchase'
                }
                this.errorAlert(fnName, error, popUpInClub);
                return error;
            });
    }

    private async callCloudFunction(fnName: string, payload: any, successHeader: ISuccessHeader, bypassLoading = false, popUpInClub = false): Promise<any | Error> {
        const fn = httpsCallable(this.cloudFNs, fnName);
        if (fnName !== 'addToSopoBalance' && !bypassLoading) {
            this.loadingCtrl.present('cloud');
        }
        return fn(payload)
            .then(async (value) => {
                if (!bypassLoading) this.loadingCtrl.dismiss('cloud');
                // TODO: Refactor to remove dependency of modal and nav ctrl?
                if (Object.keys(successHeader).length > 0) {
                    if (fnName === 'disbandClub') {
                        this.modalCtrl.dismiss();
                        this.navCtrl.navigateRoot('/lobby');
                    }
                    if (fnName !== 'onSettingsChanged' && !bypassLoading) {
                        this.succesAlert(successHeader, popUpInClub);
                    }
                    if (fnName === 'bundlePurchaseWithCurrency') {
                        this.smartAudioService.playSounds('shop');
                    }
                }
                return payload;
            })
            .catch(async (error) => {
                this.loadingCtrl.dismiss('cloud');
                console.error(error);
                if (fnName == 'requestToJoinUnion') {
                    fnName = 'Join Union';
                }
                if (fnName == 'buyWithDiamonds') {
                    fnName = 'Purchase'
                }
                this.errorAlert(fnName, error, popUpInClub);
                return error;
            });
    }

    async getMyRole(): Promise<ClubRole> {
        return firstValueFrom(await this.getMyRoleObservable());
    }

    async getMyRoleObservable(): Promise<Observable<ClubRole>> {
        const clientId = await this.authStoreDispatcher.getMyID();
        return this.getRoleObservable(clientId);
    }

    getRole(userId: string): Promise<ClubRole> {
        return firstValueFrom(this.getRoleObservable(userId));
    }

    getRoleObservable(userId: string, clubIdOverride?: string): Observable<ClubRole> {
        const getRoleObservableFromState = (userId:string) => {
            return this.clubStateDispatch.getClubState().pipe(
                map(clubState => clubState.membersState.members.find(member => member.id === userId)!),
                map(member => member ? member.role : ClubRole.MEMBER),
            );
        };

        const getRoleObservableFromFirestore = (clubId: string, userId: string) => {
            const docReference = doc(this.firestore, `clubs/${clubId}/members/${userId}`) as DocumentReference<IClubMember>;

            return docData<IClubMember>(docReference).pipe(
                map(clubMember => clubMember ? clubMember.role : ClubRole.MEMBER),
            );
        };

        return this.clubStateDispatch.getClubState().pipe(
            distinctUntilChanged((x,y) => x.id === y.id && x.membersState.listening === y.membersState.listening),
            switchMap(clubState => {
                const clubId = clubIdOverride || clubState.id;
                if (clubId === undefined || clubId === 'SOPO') return of(ClubRole.MEMBER);
                if (clubState.membersState.listening && clubId === clubState.id) return getRoleObservableFromState(userId);
                return getRoleObservableFromFirestore(clubId, userId);
            }),
            distinctUntilChanged(),
        );
    }

    getClubMemberDataObservable(memberId: string, clubIdOverride?: string): Observable<IClubMember> {
        const getClubMemberDataObservableFromState = (userId: string) => {
            return this.clubStateDispatch.getClubState().pipe(
                map(clubState => clubState.membersState.members.find(member => member.id === userId)!),
                filter(member => member !== undefined),
            );
        }

        const getClubMemberDataObservableFromFirestore = (clubId: string, userId: string) => {
            const docReference = doc(this.firestore, `clubs/${clubId}/members/${userId}`) as DocumentReference<IClubMember>;
            return docData<IClubMember>(docReference);
        }

        return this.clubStateDispatch.getClubState().pipe(
            switchMap(clubState => {
                const clubId = clubIdOverride || clubState.id;
                if (clubId === undefined || clubId === 'SOPO') return EMPTY;
                if (clubState.membersState.listening && clubId === clubState.id) return getClubMemberDataObservableFromState(memberId);
                return getClubMemberDataObservableFromFirestore(clubId, memberId);
            }),
        );
    }

    getMemberBalanceObservable(memberId: string, clubIdOverride?: string): Observable<number> {
        return this.getClubMemberDataObservable(memberId, clubIdOverride).pipe(
            map(memberData => {
                return memberData.balance;
            }),
        );
    }

    async isUserMemberOfTheClub(clubId: string, userId: string): Promise<boolean> {
        const docReference = doc(this.firestore, `clubs/${clubId}/members/${userId}`) as DocumentReference<IClubMember>;
        const userData = await getDoc(docReference);
        return userData.data()?.id ? true : false;
    }

    private async succesAlert(successHeader: ISuccessHeader, popUpInClub = false): Promise<void> {
        const header = successHeader.header;
        const message = successHeader.message;
        this.showAlert(header, message, 2000, popUpInClub);
    }

    private async errorAlert(fnName: string, error: any, popUpInClub = false) {
        const header = `${fnName} error`;
        const message = error.error;
        this.showAlert(header, message, 5000, popUpInClub);
    }

    private async showAlert(header?: string, message?: string, dismissAfter: number = DEFAULT_DISMISS_AFTER_TIME, popUpInClub = false) {
        const extraScss = popUpInClub ? ['sopo-popup-red-background'] : [];
        this.sopoPopupService.showAlert(
            'app',
            {
                header,
                message,
                dismissAfter,
                sCss: extraScss,
            }
        );
    }

    /**
     * Throws an error if any of the key value pairs in the object returned undefined
     * @param object a regular json
     */
    /**
     * Extracts a human-readable failure message from the rejection of an
     * `apiService.createSngTournament` / `createMtTournament` call. The BE
     * returns a structured `MainServerResponseError` body whose `message`
     * field holds the actual reason (e.g. "Mystery EXPLICIT mode requires a
     * non-empty mysteryEnvelopeList."). The Angular HttpClient wraps it as
     * `HttpErrorResponse.error`, so naively binding `reason.error` to a
     * toast renders the entire object as `[object Object]`. This helper
     * unwraps both the structured shape and the plain-string fallback.
     */
    private extractCreateTournamentErrorMessage(reason: unknown): string {
        const httpErrorBody = (reason as { error?: unknown })?.error;
        if (typeof httpErrorBody === 'string') {
            return httpErrorBody;
        }
        const structured = httpErrorBody as Partial<MainServerResponseError> | undefined;
        if (structured?.message) {
            return structured.message;
        }
        const reasonMessage = (reason as { message?: string })?.message;
        return reasonMessage ?? 'Unknown error';
    }

    private throwsIfUndefined(object: any): void {
        Object.keys(object).forEach(async (key) => {
            if (object[key] === undefined) {
                const errorMsg = `Value of ${key} is undefined.`;
                console.error(errorMsg);
                this.sopoPopupService.showAlert('app', {
                    header: `Something went wrong.`,
                    message: errorMsg,
                });
                throw new Error(errorMsg);
            }
        });
    }

    async isInClub(userId: string, clubId: string): Promise<boolean | null> {
        try {
            this.loadingCtrl.present('firestore');

            const docReference = doc(this.firestore, `users/${userId}/clubs/${clubId}`);
            const docData = await getDoc(docReference);
            return docData.exists();
        } catch(error) {
            console.error(`[isUserInClub] - error checking user club - userId:${userId}, clubId:${clubId}.`, error);
            return null;
        } finally {
            this.loadingCtrl.dismiss('firestore');
        }
    }

    public mainStageGameAlreadyExists(): Observable<boolean> {
        return this.clubStateDispatch.getClubState().pipe(
            map(state => Object.keys(state.clubData.games).some(gameKey => (state.clubData.games[gameKey] as IClubGame).mainStage)),
            distinctUntilChanged()
        );
    }

    ngOnDestroy() {
        if (this.clubSubscription) {
            this.clubSubscription.unsubscribe();
        }
        if (this.clubMessagesSubscription) {
            this.clubMessagesSubscription.unsubscribe();
        }
        if (this.tableSubscribe) {
            this.tableSubscribe.unsubscribe();
        }
        if (this.membersSubscription) {
            this.membersSubscription.unsubscribe();
        }
        if (this.roleSubscription) this.roleSubscription.unsubscribe();
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}



interface ISuccessHeader {
    header?: string;
    message?: string;
}

export interface ItemTypes {
    avatars,
    felts,
    backgrounds,
    cardStyles
}
